import { render, staticRenderFns } from "./send-gift.vue?vue&type=template&id=5d32cf44&scoped=true&"
import script from "./send-gift.vue?vue&type=script&lang=js&"
export * from "./send-gift.vue?vue&type=script&lang=js&"
import style0 from "./send-gift.vue?vue&type=style&index=0&id=5d32cf44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32cf44",
  null
  
)

export default component.exports